module.exports = {
    navigation: {
        nav: ['首页', '关于', '产品', '历程', '购买', '在线商城', '联系我们', '切换语言'],
        company: location.hostname === 'wwww.xiandanmall.com' ? '厚普创优(成都)网络科技有限公司' : '成都闲蛋猫电子商务有限责任公司',
        shopping: '闲蛋(跨境)商城',
        platform: '消耗品跨境电子商城平台',
        go: '我要购买'
    },
    mallTitle: {
        title: '闲蛋',
        words: '闲蛋（跨境）电商和现在主流电商平台最大的区别在于“我们不做平台，所有商品均为自营”。我们采用"完全自营"模式，这样可以最大程度上避免鱼龙混杂，更加严格的管控商品来源。闲蛋商城主要销售化妆品、日用品、母婴产品和保健品，我们在日本、韩国、美国、澳洲等地设立办事处，深入产品原产地，直接对接品牌方、工厂、大型商超和全球顶级供应商，从源头杜绝假货，保证商品质量。顾客在商城下单后，商品会从海关监管的中国保税区发出,全程接受海关监管，进行100%阳光清关,物流信息全程可以查看。保税仓发货不同于普通进口，可享受国家税务优惠政策，从而可以在价格上与专柜、超市等其它销售渠道形成价格优势。商城采用“假货重赔”机制，赢取客户对商城的信赖。',
        contact: '联系我们'
    },
    title: {
        sale: '我们销售',
        course: '发展历程',
        pay: '购买商品',
        contact: '联系'
    },
    goods: {
        columns: ['护肤品', '日用品', '母婴用品', '保健品']
    },
    rotationChart: {
        register: {
            title: '海关注册',
            time: '2019.01',
            complete: '完成海关相关手续'
        },
        start: {
            title: '项目启动',
            time: '2018.10',
            complete: '项目开始启动，准备各种证件及系统研发工作。'
        },
        access: {
            title: '公服接入',
            time: '2019.02',
            complete: '完成对接成都跨境贸易电子商务公共服务平台。'
        },
        warehouse: {
            title: '保税仓库',
            time: '2019.03',
            complete: '与四川汇通天下物流有限公司建立合作关系。'
        },
        choice: {
            title: '产品备货',
            time: '2019.04',
            complete: '与日本供应商联系备货事宜。'
        },
        product: {
            title: '平台上线',
            time: '2019.06',
            complete: '货物到达双流机场，完成清关，顺利进入保税仓。'
        }
    },
    purchaseGoods: {
        public: '闲蛋商城公众号',
        title: '目前我们开通公众号线上购买和"扫码购"两种途径购买。请扫描左边的二维码关注我们微信公众号，上千商品应有尽有。'
    },
    contact: {
        address: {
            title: '联系地址',
            details: '中国（四川）自由贸易实验区成都天府新区湖畔路北段366号一栋一单元3楼1号'
        },
        telephone: {
            title: '联系电话'
        },
        mail: {
            title: '联系邮件'
        },
        input: {
            name: '姓名',
            mail: '邮箱',
            theme: '主题',
            say: '说点什么',
            send: '发送消息'
        }
    },
    footer: [
        {
            company: '厚普创优(成都)网络科技有限公司',
            keep: '川公网安备 51011502000300号',
            record: '蜀ICP备18037207号-1'
        },
        {
            company: '成都闲蛋猫电子商务有限责任公司',
            keep: '川公网安备 51011502000300号',
            record: '蜀ICP备19029040号-1'
        }
    ]
}
